var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "review-order" },
    [
      _c(
        "tab-heading",
        _vm._g({ attrs: { "is-next-disabled": true } }, _vm.$listeners),
        [
          _c("h2", { staticClass: "text-center" }, [_vm._v("Review & Order")]),
          _c("p", { staticClass: "lead text-center mb-0" }, [
            _vm._v("Check your choices and order your frames:"),
          ]),
        ]
      ),
      _c(
        "b-overlay",
        { attrs: { show: _vm.loadingPrices || _vm.loadingValidation } },
        [
          _c(
            "review-breakdown",
            _vm._g(
              { attrs: { label: "Size", "tab-index": 0 } },
              _vm.$listeners
            ),
            [
              _c("em", [_vm._v("Artwork Size: ")]),
              !_vm.frame.size.name
                ? _c("strong", [
                    _vm._v(
                      _vm._s(_vm.frame.size.width) +
                        "x" +
                        _vm._s(_vm.frame.size.length) +
                        "mm"
                    ),
                  ])
                : _c("strong", [_vm._v(_vm._s(_vm.frame.size.name))]),
            ]
          ),
          _c(
            "review-breakdown",
            _vm._g(
              {
                staticClass: "bg-light",
                attrs: {
                  label: "Moulding",
                  price: _vm.prices.frame.price,
                  validation: _vm.validation.frame,
                  "tab-index": 1,
                },
              },
              _vm.$listeners
            ),
            [
              _c("em", [_vm._v("ItemCode: ")]),
              _c(
                "span",
                { class: { "text-danger": _vm.frame.moulding == null } },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.frame.moulding
                          ? `${_vm.frame.moulding.sku}`
                          : "No moulding selected"
                      )
                    ),
                  ]),
                ]
              ),
              _c("br"),
              _vm.frame.moulding != null && _vm.frame.moulding.min_order > 0
                ? _c("span", { staticClass: "text-danger" }, [
                    _c("br"),
                    _vm._v(
                      "This moulding is subject to a minimum order price of "
                    ),
                    _c("strong", [
                      _vm._v("£" + _vm._s(_vm.frame.moulding.min_order)),
                    ]),
                    _vm._v("."),
                  ])
                : _vm._e(),
              !_vm.stock.frame
                ? _c("span", { staticClass: "text-danger" }, [
                    _c("br"),
                    _vm._v("(Insufficient stock)"),
                  ])
                : _vm._e(),
              _vm.frame.moulding
                ? _c("p", { staticClass: "mb-0" }, [
                    _c("small", [
                      _vm._v(
                        "Width: " +
                          _vm._s(_vm.frame.moulding.width_mm) +
                          "mm, Depth: " +
                          _vm._s(_vm.frame.moulding.depth_mm) +
                          "mm, Rebate Depth: " +
                          _vm._s(_vm.frame.moulding.rebate_depth_mm) +
                          "mm,"
                      ),
                      _c("br"),
                      _vm._v(
                        "Profile: " +
                          _vm._s(_vm.frame.moulding.profile.name) +
                          ", Wood Type: " +
                          _vm._s(_vm.frame.moulding.material_type.name)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "review-breakdown",
            _vm._g(
              {
                attrs: {
                  label: "Mounts",
                  price: _vm.prices.mount.price,
                  validation: _vm.validation.mount,
                  "is-chosen": _vm.frame.mount.type != "none",
                  "tab-index": 2,
                },
              },
              _vm.$listeners
            ),
            [
              _vm.frame.mount.type != "none"
                ? _c("div", { staticClass: "mount-breakdown" }, [
                    _c("em", [_vm._v("Type: ")]),
                    _vm.frame.mount.type == "single"
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(
                              "Single 1.4mm - " + _vm._s(_vm.mountWidth) + "mm"
                            ),
                          ]),
                          _vm._v(
                            " wide (Aperture: " +
                              _vm._s(_vm.apertureSize.width) +
                              "x" +
                              _vm._s(_vm.apertureSize.length) +
                              "mm)"
                          ),
                        ])
                      : _c("span", [
                          _c("strong", [
                            _vm._v(
                              "Double  2 x 1.4mm - " +
                                _vm._s(_vm.mountWidth) +
                                "mm"
                            ),
                          ]),
                          _vm._v(
                            " wide (Aperture: " +
                              _vm._s(_vm.apertureSize.width) +
                              "x" +
                              _vm._s(_vm.apertureSize.length) +
                              "mm) with a "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.frame.mount.reveal) + "mm"),
                          ]),
                          _vm._v(" reveal."),
                        ]),
                    _c("br"),
                    _c("em", [_vm._v("Colours: ")]),
                    _vm.frame.mount.type == "single"
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.frame.mount.top.name)),
                          ]),
                        ])
                      : _c("ul", { staticClass: "mb-0" }, [
                          _c("li", [
                            _c("em", [_vm._v("Top:")]),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.frame.mount.top.name)),
                            ]),
                            !_vm.stock.topMount
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("(Insufficient stock)"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("li", [
                            _c("em", [_vm._v("Bottom:")]),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.frame.mount.bottom.name)),
                            ]),
                            !_vm.stock.bottomMount
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("(Insufficient stock)"),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                  ])
                : _c("span", [_vm._v("None")]),
            ]
          ),
          _c(
            "review-breakdown",
            _vm._g(
              {
                staticClass: "bg-light",
                attrs: {
                  label: "Glazing",
                  price: _vm.prices.glazing.price,
                  validation: _vm.validation.glazing,
                  "is-chosen": _vm.frame.glazing != null,
                  "tab-index": 3,
                },
              },
              _vm.$listeners
            ),
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.frame.glazing ? _vm.frame.glazing.name : "None")
                ),
              ]),
              !_vm.deliveryValidation.glazing.isValid
                ? _c("span", { staticClass: "text-danger" }, [
                    _c("br"),
                    _vm._v("Not available for delivery in this size"),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "review-breakdown",
            _vm._g(
              {
                attrs: {
                  label: "Backing Board",
                  price: _vm.prices.backing.price,
                  validation: _vm.validation.backing,
                  "is-chosen": _vm.frame.extras.backing,
                  "tab-index": 4,
                },
              },
              _vm.$listeners
            ),
            [
              _vm._v(
                _vm._s(_vm.frame.extras.backing ? "2.3mm Craftboard" : "None")
              ),
            ]
          ),
          _c(
            "review-breakdown",
            _vm._g(
              {
                staticClass: "bg-light",
                attrs: {
                  label: "Fixings",
                  price: _vm.prices.fixings.price,
                  "is-chosen": _vm.frame.extras.fixings,
                  "tab-index": 4,
                },
              },
              _vm.$listeners
            ),
            [
              _vm._v(
                _vm._s(
                  _vm.frame.extras.fixings
                    ? "2 D-rings and string to hang"
                    : "None"
                )
              ),
            ]
          ),
          _vm.frame.extras.undermount
            ? _c(
                "review-breakdown",
                _vm._g(
                  {
                    attrs: {
                      label: "Undermount",
                      price: _vm.prices.undermount.price,
                      validation: _vm.validation.undermount,
                      "is-chosen": _vm.frame.extras.undermount,
                      "tab-index": 4,
                    },
                  },
                  _vm.$listeners
                ),
                [
                  _vm._v(
                    _vm._s(
                      _vm.frame.extras.undermount
                        ? "1.4mm White Larson-Juhl Undermount"
                        : "None"
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm.frame.extras.fastmount
            ? _c(
                "review-breakdown",
                _vm._g(
                  {
                    staticClass: "bg-light",
                    attrs: {
                      label: "Fastmount",
                      price: _vm.prices.fastmount.price,
                      validation: _vm.validation.fastmount,
                      "is-chosen": _vm.frame.extras.fastmount,
                      "tab-index": 4,
                    },
                  },
                  _vm.$listeners
                ),
                [
                  _vm._v(
                    _vm._s(
                      _vm.frame.extras.fastmount
                        ? "1.5mm Permanent Sticky Fastmount"
                        : "None"
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm.frame.extras.spacer
            ? _c(
                "review-breakdown",
                _vm._g(
                  {
                    attrs: {
                      label: "Spacer",
                      price: _vm.prices.spacer.price,
                      "is-chosen": _vm.frame.extras.spacer,
                      "tab-index": 4,
                    },
                  },
                  _vm.$listeners
                ),
                [
                  _vm._v(
                    _vm._s(_vm.frame.extras.spacer ? "1.5mm Spacer" : "None")
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "b-alert",
            {
              staticClass: "mt-3",
              attrs: {
                show: !_vm.isValid || !_vm.isDeliveryAvailable,
                variant: "warning",
              },
            },
            [
              !_vm.isValid
                ? _c("span", [
                    _vm._v(
                      "We are unable to manufacture this frame to your requirements.  Please check the rows above to find and resolve the problem."
                    ),
                  ])
                : _c("span", [
                    _vm._v("Mail order delivery is "),
                    _c("strong", [_vm._v("not available")]),
                    _vm._v(
                      " with the options chosen, but you are welcome to collect the frame from "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/picture-framer/visit-chesterfield-framers",
                          target: "_blank",
                        },
                      },
                      [_vm._v("our workshop")]
                    ),
                    _vm._v("."),
                  ]),
            ]
          ),
          _c("h3", { staticClass: "display-5 text-right my-4" }, [
            _vm._v("Total Price per Frame: "),
            _c("strong", [_vm._v("£" + _vm._s(_vm.discountedPrice))]),
            _vm.discount > 0
              ? _c("small", [
                  _c("br"),
                  _c("em", [_vm._v("(Save " + _vm._s(_vm.discount) + "%)")]),
                ])
              : _vm._e(),
          ]),
          _c(
            "b-row",
            {
              class: { "border-bottom": _vm.frame.moulding },
              attrs: { "align-h": "end" },
            },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Quantity:",
                        "label-cols": "5",
                        "label-size": "lg",
                        "label-align": "right",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "lg",
                          type: "number",
                          number: "",
                          step: "1",
                          min: "1",
                        },
                        model: {
                          value: _vm.selectedQuantity,
                          callback: function ($$v) {
                            _vm.selectedQuantity = $$v
                          },
                          expression: "selectedQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show:
                          !_vm.stock.frame ||
                          !_vm.stock.topMount ||
                          !_vm.stock.bottomMount,
                        variant: "danger",
                      },
                    },
                    [
                      !_vm.stock.frame
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v("There is not enough stock of the "),
                            _c("strong", [_vm._v("moulding")]),
                            _vm._v(" you have chosen to fulfil your order."),
                          ])
                        : _vm._e(),
                      !_vm.stock.topMount
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v("There is not enough stock of the "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.frame.mount.type == "double" ? "top " : ""
                                ) + "mountboard"
                              ),
                            ]),
                            _vm._v(" you have chosen to fulfil your order."),
                          ])
                        : _vm._e(),
                      !_vm.stock.bottomMount
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v("There is not enough stock of the "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.frame.mount.type == "double"
                                    ? "bottom "
                                    : ""
                                ) + "mountboard"
                              ),
                            ]),
                            _vm._v(" you have chosen to fulfil your order."),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "lg",
                        variant:
                          _vm.isValid && _vm.isInStock ? "success" : "danger",
                        disabled: _vm.isAddToCartDisabled,
                      },
                      on: { click: _vm.addToCart },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-2" }, [
                        _vm._v("shopping_cart"),
                      ]),
                      _vm._v(
                        "Add to Cart (£" +
                          _vm._s(_vm.totalPrice) +
                          " " +
                          _vm._s(_vm.vatMode) +
                          " VAT)"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.frame.moulding
        ? _c(
            "b-row",
            { staticClass: "mt-3", attrs: { "align-v": "center" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "mb-3 mb-sm-0 text-center",
                  attrs: { order: "1" },
                },
                [
                  _c("p", [
                    _vm._v(
                      "You can also purchase this frame as a DIY chop service, or buy individual lengths and packs of picture frame moulding to use in your own DIY projects."
                    ),
                  ]),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "info",
                        href: `/picture-frame-mouldings/detail/Moulding/${_vm.frame.moulding.itemCode}`,
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("handyman"),
                      ]),
                      _vm._v("DIY Frame Options"),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "6", xl: "4", order: "1", "order-sm": "2" } },
                [
                  _c("discounts-breakdown", {
                    attrs: {
                      "sku-prefix": "BF",
                      "item-type": "Frame",
                      price: _vm.exVatPrice,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }